import { call, put, takeLatest } from "redux-saga/effects";
import { danhMucApi } from "../../../api/category/danhMucApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eKhoiActionTypeIds, IKhoiActions } from "../../action-types/category/IKhoiActionType";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.category.khoi;

export function* khoiSaga(): any {
    yield takeLatest(eKhoiActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IKhoiActions): any {
    const res: IBaseRespone = yield call(danhMucApi.SelectAllKhoi)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
